import React, { createContext, useContext } from 'react';

const LiveEventContext = createContext(null);

export const useLiveEvent = () => {
  const ctx = useContext(LiveEventContext);
  if (!ctx) throw new Error('useLiveEvent must be used within LiveEventProvider');
  return ctx;
};

export const LiveEventProvider = ({ children, value }) => (
  <LiveEventContext.Provider value={value}>
    {children}
  </LiveEventContext.Provider>
);

export default LiveEventContext;
